import * as React from "react"
import { Col, Hidden, Row, Visible } from "react-grid-system"
import styled from "styled-components"
import H2 from "../../../atoms/typography/H2"
//@ts-ignore
import IntelsatLogo from "../../../atoms/icons/images/intelsatlogo.svg"
import { HorizontalSpacer } from "../../../atoms/spacers"
import SelectDataPlanButton from "../../../molecules/store/CustomizeAndOrder/SelectDataPlanButton"
import TextButton from "../../../atoms/buttons/TextButton"
import { ArrowDropDownIcon } from "../../../atoms/icons/ArrowDropDownIcon"
import H4 from "../../../atoms/typography/H4"
import SmallColorfulButton from "../../../atoms/buttons/SmallColorfulButton"
import { ArrowRight } from "../../../atoms/icons/ArrowRight"
import { getDataPlan } from "../../../../hooks-saleor/getDataPlanQuery"
import LoadingSpinner from "../../../atoms/LoadingSpinner"
import { Variant } from "../../../interfaces/SaleorTypes"
import { getFormattedPrice } from "../../../../utils/cart-helpers"
import { SlideOutHeight } from "../../../atoms/animations/SlideOutHeight"
import Body from "../../../atoms/typography/Body"
import { ArrowDropUpIcon } from "../../../atoms/icons/ArrowDropUpIcon"
import { theme } from "../../../theme"

interface DefaultValues {
  dataPlanVariant?: Variant
}

interface Props {
  onClickNextStep: (dataplanTotal: number, dp?: Variant) => void
  numberOfTerminals: number
  defaultValues?: DefaultValues
  terminalTotal: number
  currency?: string
}

const FlexedText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const CustomizeDataPlan: React.FC<Props> = ({
  onClickNextStep,
  numberOfTerminals,
  defaultValues,
  terminalTotal,
  currency,
}) => {
  const { dataPlan, loading, error } = getDataPlan()
  const [selectedDataPlan, setSelectedDataPlan] = React.useState<undefined | Variant>(defaultValues?.dataPlanVariant)
  const [showDataPlanInfo, setShowDataPlanInfo] = React.useState(false)
  const isKu = window.location.href.includes("ku")

  if (loading) {
    return <LoadingSpinner />
  }

  const onClickNoDataPlan = () => {
    onClickNextStep(0, undefined)
  }

  const onClickNext = () => {
    onClickNextStep((selectedDataPlan?.pricing?.price?.gross?.amount ?? 0) * numberOfTerminals, selectedDataPlan)
  }

  return (
    <div>
      <Row>
        <Col lg={6}>
          <Image src="https://images.ctfassets.net/kzqg847wz5jr/6pN97JUyaf153c6mb3MKY/38df144d4a004586d18a2b50c0a97d39/intelsatflexmove_coverage_copy.webp" />
        </Col>
        <Col lg={6}>
          <FlexedText>
            <H2>Data plan</H2>
            <IntelsatLogo />
          </FlexedText>
          <HorizontalSpacer spacing={1.5} />
          {dataPlan.variants.map((dp: Variant) => (
            <div key={dp.id}>
              <SelectDataPlanButton
                title={dp.metadata[0]?.value}
                size={dp.name}
                validity="1 year validity"
                price={`${getFormattedPrice(dp.pricing.price.gross.amount, dp.pricing.price.currency)}`}
                selected={selectedDataPlan === dp}
                onClick={() => setSelectedDataPlan(dp)}
                gradient={isKu ? theme.gradients.blueBorder : theme.gradients.greenBorder}
              />
              <HorizontalSpacer spacing={1} />
            </div>
          ))}

          <HorizontalSpacer spacing={0.5} />
          <TextButton title="Proceed without data plan" onClick={onClickNoDataPlan} />
          <HorizontalSpacer spacing={1.5} />
          <TextButton
            title="Data plan information"
            icon={showDataPlanInfo ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            onClick={() => setShowDataPlanInfo(!showDataPlanInfo)}
          />
          <SlideOutHeight isVisible={showDataPlanInfo}>
            <HorizontalSpacer spacing={1.5} />
            <Body>
              Data plans can be exclusive to a single terminal or shared for a pool of terminals. Only single data plans
              can be purchased online.
              <br />
              <br />
              If you would like to purchase a shared data plan, please contact us at sales@satcube.com.
            </Body>
          </SlideOutHeight>
          <HorizontalSpacer spacing={1.5} />
          <FlexedText>
            <div>
              <H4>Total:</H4>
              <H4>
                {selectedDataPlan
                  ? `${getFormattedPrice(
                      selectedDataPlan.pricing.price.gross.amount * numberOfTerminals + terminalTotal,
                      selectedDataPlan.pricing.price.currency,
                    )}`
                  : getFormattedPrice(terminalTotal, currency)}
              </H4>
            </div>
            <Hidden xs>
              <SmallColorfulButton
                title="Next step: Accessories"
                iconRight={<ArrowRight color="white" />}
                onClick={onClickNext}
                variant={isKu ? "blue" : "green"}
              />
            </Hidden>
          </FlexedText>

          <Visible xs>
            <HorizontalSpacer spacing={3} />
            <SmallColorfulButton
              title="Next step: Accessories"
              iconRight={<ArrowRight color="white" />}
              onClick={onClickNext}
              variant={isKu ? "blue" : "green"}
            />
          </Visible>
        </Col>
      </Row>
      <HorizontalSpacer spacing={1.5} />
    </div>
  )
}

export default CustomizeDataPlan
